import { createContext, type Dispatch, type ReactNode } from "react";
import {
  reducer,
  ScheduleReferenceDataState,
  type ScheduleReferenceDataStateAction,
} from "@/pages/human-resources/time-management/schedules/reference-provider/ScheduleReferenceDataState.ts";
import { useImmerReducer } from "use-immer";

// eslint-disable-next-line react-refresh/only-export-components
export const ScheduleReferenceDataStateContext = createContext<
  ScheduleReferenceDataState | undefined
>(undefined);

// eslint-disable-next-line react-refresh/only-export-components
export const ScheduleReferenceDataStateDispatchContext = createContext<
  Dispatch<ScheduleReferenceDataStateAction> | undefined
>(undefined);

export default function ScheduleReferenceDataStateProvider(props: {
  children: ReactNode;
}): ReactNode {
  const [refDataState, dispatch] = useImmerReducer(
    reducer,
    new ScheduleReferenceDataState(),
  );
  return (
    <ScheduleReferenceDataStateContext.Provider value={refDataState}>
      <ScheduleReferenceDataStateDispatchContext.Provider value={dispatch}>
        {props.children}
      </ScheduleReferenceDataStateDispatchContext.Provider>
    </ScheduleReferenceDataStateContext.Provider>
  );
}
